module.exports = __webpack_public_path__ + "img/schwack.5cbce99f.jpg";